import { PropsWithChildren, useLayoutEffect, useMemo } from 'react'

import { model } from '@formily/reactive'
import { Spin } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { FormGridProps } from '../../FormGrid/interface'
import { SchemaForm } from '../../SchemaForm'
import { useCrudFormStore } from '../Store/hooks/useStore'

import { CrudFormCoreProps } from './interface'

const defaultGrid: FormGridProps = {
  columns: 1,
  rowGap: 0,
  columnGap: 8,
  minWidth: 200
}

export const CrudFormCore = ({
  /* -------------------------------------------------------------------------- */
  /*                              SchemaForm Props                              */
  /* -------------------------------------------------------------------------- */
  grid,
  ...restProps
}: PropsWithChildren<CrudFormCoreProps>) => {
  const { context, readLoading, form } = useCrudFormStore(state =>
    pick(state, ['context', 'readLoading', 'form'])
  )

  const scope = useMemo(() => model({ $context: {} }), [])

  useLayoutEffect(() => {
    Object.assign(scope.$context, context ?? {})
  }, [context, scope])

  const mergeGrid = {
    ...defaultGrid,
    ...grid
  }

  return (
    <Spin spinning={readLoading}>
      <SchemaForm {...restProps} form={form} grid={mergeGrid} scope={scope} />
    </Spin>
  )
}
